// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.dfinnwallet",
    name: "Dfinn Wallet",
    homepage: "https://dfinnwallet.app",
    image_id: "9a9c59ce-6346-4af8-db19-778533fb6000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/dfinn-wallet/id6451134219",
        android: "https://play.google.com/store/apps/details?id=money.dfinn.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "dfinnwallet://",
        universal: "https://dfinnwallet-link.vercel.app/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map